import { checkLandingEntryABTestingPassed } from '@/common/bot/lib/abTesting';
import { Country } from './config';
import { get } from './environment';

export type IsLandingEntrySupportedParams = {
  country?: Country | string | null;
  userId?: string | number | null;
};

export const resolveLandingEntryUserId = (
  isAuthenticated: boolean,
  userId?: string | number | null
): string | number | undefined => {
  if (!isAuthenticated) {
    return undefined;
  }

  return userId ?? undefined;
};

export const isLandingEntrySupported = ({ country, userId }: IsLandingEntrySupportedParams = {}): boolean => {
  const resolvedCountry = country ?? get('country');
  if (!resolvedCountry) {
    return false;
  }

  const landingEntryLsValue = localStorage.getItem('landing-entry-enabled');
  if (landingEntryLsValue === 'true') {
    return true;
  }

  const abPercentage = get('landingEntryAbPercentage')?.[resolvedCountry as Country];

  return checkLandingEntryABTestingPassed({
    userId: userId ?? undefined,
    abPercentage,
    checkBypass: false,
  });
};
